import React from 'react';

const Terms: React.FC = () => (
  <div className="min-h-screen bg-gray-50">
    <section className="bg-blue-50 pt-16 pb-16 mt-16">
      <div className="max-w-3xl mx-auto bg-white rounded-xl shadow p-8">
        <h1 className="text-3xl font-bold mb-6 text-blue-800">服帮帮用户服务协议</h1>
        <div className="prose prose-blue max-w-none">
          <p>更新日期：2025年10月13日</p>
          <h2>特别提示</h2>
          <p>欢迎您加入服帮帮，与平台经营者（具体定义见相关条款）共同签署《服帮帮用户服务协议》（以下简称 “本协议”），并使用我们的平台服务！本协议是经过修订的版本，自发布之日起，平台各处提及的 “服帮帮用户服务协议” 均指本协议。</p>
          <p>各服务条款前的索引关键词，仅为方便您快速把握条款主旨，不影响也不限制本协议条款的实际含义和解释。为了切实保障您的合法权益，建议您仔细研读各条款的具体内容。</p>
          <p><strong>【审慎阅读】</strong>在申请注册流程中点击同意本协议之前，请您务必认真、审慎地阅读本协议。请充分理解协议中的每一项条款，尤其是涉及责任免除、责任限制、法律适用以及争议解决的条款。若您对协议内容存在任何疑问，可随时联系服帮帮的客服团队进行咨询 。</p>
          <p><strong>【签约动作】</strong>当您依照注册页面的指引，准确填写信息、认真阅读并同意本协议，完成全部注册步骤后，即表明您已充分理解并接受本协议的全部内容，与服帮帮达成一致，正式成为平台的 “用户”。在阅读本协议的过程中，若您对本协议或其中任何条款存在异议，请立即停止注册程序。</p>
          <p>本 “特别提示” 是本协议正文的组织部分。</p>
          <h2>1. 定义</h2>
          <p>1.1 服帮帮：涵盖服帮帮小程序等各类网站、客户端、微信公众号等，以及未来技术发展出现的新的软件载体等。</p>
          <p>1.2 服帮帮所有者：是服帮帮平台经营者，即黄山智衣信息科技有限公司（以下也称 “我们”）。</p>
          <p>1.3 服帮帮平台服务：服帮帮依托互联网及移动互联网，通过包含服帮帮小程序、客户端等在内的各种形式（包含未来因技术发展而产生的全新服务形式），向您提供的各类服务。</p>
          <p>1.4 服帮帮平台规则：囊括在所有服帮帮平台规则频道已发布以及后续发布的全部规则、解读、公告等内容，同时还包括各平台在公告、帮助中心发布的各类规则、实施细则、产品流程说明、公告等。具体是指服帮帮平台规则频道中所列举的各项规则，包括所有平台已经发布或将来可能发布、修订的各类规则、规范、规则解读、实施细则、通知、公告。</p>
          <p>1.5 服帮帮规则：具体指服帮帮规则频道中所列举的各项规则，包括所有平台已经发布或将来可能发布、修订的各类规则、规范、规则解读、实施细则、通知、公告。</p>
          <p>1.6 订单公司/加工厂/供应链/终端公司：是指按照服帮帮规定的程序或和要求，完成资格审核并入驻平台的法律实体。商家通过平台独立向您销售商品/需求服务。独立承担商品销售/需求服务提供者的法律责任。</p>
          <p>1.7 第三方支付公司：指具备提供支付服务资质的第三方支付主体。</p>
          <p>1.8 关联公司：除服帮帮平台经营者之外的，与之存在特定关联关系的单称或合称。</p>
          <p>1.9 同一用户：若使用同一手机号信息，或经服帮帮排查确认多个服帮帮账户的实际控制人为同一人，以及使用同一设备、IP地址或其他技术手段注册的账户，经平台判定为同一用户的，均视作同一用户。</p>
          <h2>2. 协议范围</h2>
          <p>2.1 签约主体</p>
          <p><strong>【平等主体】</strong>本协议由您与服帮帮平台经营者在平等、自愿的基础上共同缔结，对双方均具有法律约束力，双方的权利和义务均受本协议约束。</p>
          <p><strong>【主体信息】</strong>服帮帮平台经营者是指依法运营服帮帮平台的各个法律主体。您可随时查阅服帮帮平台各网站首页底部公示的证照信息，以明确与您履行本协议的具体服帮帮主体。在本协议履行期间，服帮帮平台经营者可能因平台业务调整而发生变更。变更后的服帮帮平台经营者将继续与您履行本协议，并为您提供服务，此变更不会对您在本协议项下享有的合法权益造成任何不利影响。此外，随着服帮帮平台业务的拓展，可能会新增提供服务的服帮帮平台经营者。若您使用新增的服帮帮平台服务，即视为您同意新增的服帮帮平台经营者加入本协议，并与您共同履行本协议。当发生争议时，您可依据您实际使用的服务内容以及对您权益产生影响的具体行为主体，来确定与您履行协议的主体以及争议相对方。</p>
          <p>2.2补充协议</p>
          <p>鉴于互联网行业的快速发展特性，本协议所列举的条款虽已全面涵盖双方的主要权利和义务，但无法详尽罗列所有情形，且现有约定难以完全契合未来业务发展的需求。因此，服帮帮平台法律声明及隐私权政策、服帮帮平台规则等均作为本协议的补充协议，与本协议构成不可分割的整体，具有同等法律效力。一旦您使用服帮帮平台服务，即表明您认可并同意上述补充协议的全部内容。</p>
          <h2>3. 账户注册与使用</h2>
          <p>3.1 用户资格</p>
          <p>您确认，在开始注册程序并使用服帮帮服务前，请您确认自身具备中华人民共和国法律规定的、与行为相适应的民事行为能力。若不具备相应民事行为能力，您及您的监护人需依照法律规定承担由此导致的一切后果。若不具备相应民事行为能力，应在监护人的指导下使用平台服务，监护人需对用户的行为承担由此导致的一切责任和后果。</p>
          <p>3.2 账户登录</p>
          <p>按照注册页面提示填写信息、阅读并同意本协议，完成全部注册程序后，您将获得服帮帮账户，成为平台用户。您有权使用自行设置或确认的手机号码（以下简称 “账户名称”）登录平台。</p>
          <p>平台仅允许每位用户使用一个平台账户。若有证据证明，或平台有理由相信您存在不当注册、不当使用多个平台账户的情况，平台将采取冻结或关闭账户、取消订单、拒绝提供服务等措施。如给平台及相关方造成损失，您还需承担赔偿责任。</p>
          <p>3.3 账户注册</p>
          <p>注册使用平台服务时，请按平台页面提示，准确、完整地提供个人信息，包括姓名、电子邮件地址、联系电话、联系地址；若涉及认证，需提供真实有效的身份证、营业执照等。这些信息将用于平台或其他用户与您联系。请您知悉并同意，保持所提供信息的真实性和有效性是您的义务。</p>
          <p>3.4 账户保管</p>
          <p>您的账户由您自行设置并保管，平台任何时候都不会主动要求您提供账户密码。建议您务必妥善保管账户，在每个上网时段结束时，按正确步骤退出登录并离开平台。</p>
          <p>因您主动泄露账户信息，或遭受他人攻击、诈骗等行为导致的损失及后果，平台不承担责任。您应通过司法、行政等救济途径向侵权行为人追偿。除平台存在过错外，您需对账户项下的所有行为结果负责，包括但不限于在线签署各类协议、发布信息、购买商品及需求服务、披露信息等。</p>
          <p>3.5 账户注销</p>
          <p>您可在小程序 “我的 - 设置 - 账户注销” 处进行账户注销操作，但需符合《服帮帮账号注销规则》的相关要求。注销账号后，平台将无法继续为您提供服务，您也无法再使用该账号。主动注销账号后，我们将停止服务，并严格按照法律、法规要求，删除您的个人信息或进行匿名化处理。</p>
          <h2>4. 服帮帮平台服务及规范</h2>
          <p><strong>【服务概况】</strong>您凭借在服帮帮注册的身份，享有对应权限，可在平台上开展一系列活动，包括发布订单、接单、对订单进行评价、处理交易争议、阅读消息公告以及参与平台活动等。服帮帮提供的服务丰富多样，若您想详细了解，可随时登录平台进行浏览查看。</p>
          <h3>4.1 发布及申请</h3>
          <p><strong>【订单发布】</strong>当您注册成为 “订单公司/订单方” 等身份，并完成身份实名认证（需上传身份证或营业执照进行认证）以及线下现场审核后，便具备编辑发布加工订单的资格。此时，您可以在平台上发布加工订单及 / 或服务信息，进而与其他用户达成交易合作。</p>
          <p><strong>【订单申请】</strong>当您注册成为 “加工公司/加工厂” 等身份，并完成身份实名认证（需上传身份证或营业执照进行认证）以及线下现场审核后，便具备订单申请的资格。此时，您可以在平台上申请已发布的加工订单及 / 或服务。</p>
          <p><strong>【产能发布】</strong>当您注册成为 “加工公司/加工厂” 等身份，并完成身份实名认证（需上传身份证或营业执照进行认证）以及线下现场审核后，便具备产能发布的资格。此时，您可以在平台上发布产能信息或服务。</p>
          <p>需注意，基于服帮帮的有效管理需求，同一用户在平台上仅能以单一身份登录，且每个身份均需独立完成认证。若身份未独立完成认证，该身份所对应的核心功能将无法使用。</p>
          <h3>4.2 订单或服务的销售与推广</h3>
          <p><strong>【订单或服务信息发布】</strong>通过服帮帮提供的服务，您有权通过文字、图片、视频、音频等形式在服帮帮平台上发布订单或服务信息、招揽和物色交易对象、达成交易。</p>
          <p><strong>【禁止销售范围】</strong>您应当确保您对您在服帮帮平台上发布的订单及/或服务享有相应的权利，您不得在服帮帮平台上销售以下商品或提供以下服务：</p>
          <ul>
            <li>（1）国家禁止或限制的；</li>
            <li>（2）侵犯他人知识产权或其它合法权益的；</li>
            <li>（3）服帮帮平台规则、公告、通知或各平台与您单独签署的协议中已明确说明不适合在服帮帮平台上销售或提供的。</li>
          </ul>
          <p><strong>【交易秩序保障】</strong>您应当遵守诚实信用原则，确保您所发布的订单商品及 / 或服务信息真实、与您实际所销售的订单商品及 / 或服务提供的服务相符，并在交易过程中切实履行您的交易承诺。</p>
          <p>您应当维护服帮帮平台市场良性竞争秩序，不得贬低、诋毁竞争对手，不得干扰服帮帮平台上进行的任何交易、活动，不得以任何不正当方式提升或试图提升自身的信用度，不得以任何方式干扰或试图干扰服帮帮平台的正常运作。</p>
          <p><strong>【依法纳税】</strong>依法纳税是每一个公民、企业应尽的义务，您应对销售额/营业额超过法定免征额部分及时、足额地向税务主管机关申报纳税。</p>
          <h3>4.3 曝光台</h3>
          <p>为维护服帮帮的公平、公正与诚信交易环境，保障广大用户的合法权益，平台特设立曝光台。对于严重违反平台规则、损害其他用户利益或扰乱市场秩序的行为，平台将予以公开曝光。</p>
          <p><strong>【曝光范围】</strong></p>
          <ul>
            <li>（1）发布虚假信息：在平台上发布与实际商品或服务严重不符的虚假信息，包括但不限于虚假的需求服务描述、图片盗用、虚构服务内容等，误导其他用户做出错误的交易决策。</li>
            <li>（2）交易违规违法：在买卖双方交易过程中，出现欺诈、恶意违约、侵犯知识产权、销售假冒伪劣商品、违反法律法规规定的交易行为，以及任何利用平台进行非法活动的行为。</li>
            <li>（3）不履行合同约定：签订交易合同后，无正当理由拒绝履行合同义务，如不按时发货、不提供约定的服务、拒绝退换货、带款提货、擅自变更合同条款等，严重影响交易的正常进行和对方用户的权益。</li>
          </ul>
          <p><strong>【曝光方式】</strong></p>
          <p>平台将在显著位置，如平台首页、公告板块等，对违规用户的相关信息及违规行为进行公示。公示内容可能包括违规用户的账号名称、注册信息（部分脱敏处理）、违规行为详情、涉及的交易订单编号、违规行为发生时间等，以确保曝光信息的真实性和可追溯性。</p>
          <p><strong>【曝光效力】</strong></p>
          <ul>
            <li>（1）对违规用户形成警示和约束，促使其改正错误行为，增强平台用户的自律意识和诚信意识。</li>
            <li>（2）为其他用户提供参考，帮助用户在交易前了解潜在交易对象的信用状况，避免与不良用户进行交易，降低交易风险。</li>
            <li>（3）违规行为一经曝光，平台将根据违规情节严重程度，依据平台规则对违规用户采取相应的处罚措施，包括但不限于限制账号功能、扣除信用积分、暂停或终止平台服务、追究相应法律责任等。</li>
          </ul>
          <p><strong>【申诉途径】</strong></p>
          <p>如被曝光用户对曝光内容存在异议，可在曝光信息发布后的 7个工作日内，向平台提交申诉材料，说明情况并提供相关证据。平台将在收到申诉后的 30 个工作日内进行审核，并根据审核结果决定是否撤销或修正曝光信息。</p>
          <h2>5. 商品及/或服务的购买与评价</h2>
          <p>5.1 商品及 / 或服务的购买</p>
          <p>在服帮帮选购商品及 / 或服务时，请您务必审慎确认各项关键信息。包括但不限于商品及 / 或服务的名称、价格、数量、型号、规格、尺寸，以及服务的时间、内容、限制性要求等。下单之际，还需仔细核实您的联系地址、电话以及收货人等信息。若您填写的收货人并非您本人，那么该收货人在交易过程中的行为以及所表达的意思表示，由此产生的一切法律后果均由您承担。</p>
          <p>您的交易行为应当基于真实的消费需求，严禁出现恶意发布商品及 / 或服务信息、恶意抢单、恶意维权等扰乱服帮帮正常交易秩序的行为。为维护平台的交易秩序与交易安全，一旦服帮帮发现上述情形，有权主动执行关闭相关交易订单等操作。</p>
          <h3>5.2 评价</h3>
          <p>您享有在服帮帮提供的评价系统中，对与您完成交易的其他用户所提供的商品及 / 或服务进行评价的权利。需知晓，您在平台上的评价信息将向公众公开。若您不希望在评价内容中向公众披露个人身份信息，您有权选择以匿名形式发表评价。</p>
          <p>您的所有评价行为需严格遵循服帮帮规则的相关规定。评价内容应客观、真实，不得包含任何污言秽语、色情低俗内容、广告信息，以及法律法规和本协议明确禁止的其他信息。同时，您不应以不正当手段帮助他人提升信用，也不得利用评价权利对其他用户进行威胁、敲诈勒索。若您违反上述规定，服帮帮将按照平台规则，对您所产生的评价信息进行删除或屏蔽处理。</p>
          <h3>5.3 评分机制</h3>
          <p>为了构建公平、诚信、高效的交易环境，服帮帮特制定全面、科学的用户评分体系。该体系从多个关键维度对用户进行综合评估，以便为平台内的所有用户提供可靠的交易参考，促进平台的健康、有序发展。</p>
          <h2>6. 交易争议处理</h2>
          <h3>6.1 交易争议处理途径</h3>
          <p>在服帮帮进行交易期间，若您与其他用户发生争议，您或其他用户中的任何一方均有权自主选择以下途径解决争议：</p>
          <ul>
            <li>（1）与争议相对方自行协商解决；</li>
            <li>（2）运用服帮帮提供的争议调处服务；</li>
            <li>（3）请求消费者协会或者其他依法成立的调解组织进行调解；</li>
            <li>（4）向有关行政部门投诉；</li>
            <li>（5）依据与争议相对方达成的仲裁协议（若有），提请仲裁机构仲裁；</li>
            <li>（6）向人民法院提起诉讼。</li>
          </ul>
          <h3>6.2 平台调处服务</h3>
          <p>若您依据服帮帮规则，使用平台的争议调处服务，即表明您认可并愿意履行由平台客服或大众评审员（以下统称 “调处方”）作为独立第三方，根据其了解到的争议事实，依据平台规则所作出的调处决定。该决定包括但不限于调整相关订单的交易状态、判定将争议款项的全部或部分支付给交易一方或双方等。</p>
          <p>在服帮帮作出调处决定前，您可选择上述第 3、4、5、6 项途径（以下简称 “其他争议处理途径”）解决争议，以中止平台的争议调处服务。</p>
          <p>若您对调处决定不满意，仍有权通过其他争议处理途径解决争议。但在通过其他争议处理途径未取得终局决定之前，您仍需先行履行调处决定。</p>
          <h2>7. 费用</h2>
          <p>服帮帮为向您提供服务投入了大量成本。除平台明示的收费业务外，目前平台向您提供的服务均为免费。若未来平台需向您收取合理费用，将通过合理途径，并以足够合理的期限，提前依照法定程序，再告知您，确保您拥有充分的自主选择权。</p>
          <h2>8. 责任限制</h2>
          <h3>8.1 不可抗力及第三方原因</h3>
          <p>服帮帮始终严格依照法律规定，切实履行基础保障义务。然而，面对以下原因致使的合同履行障碍、履行存在瑕疵、履行延迟或者履行内容发生变更等情形，服帮帮无需承担相应的违约责任：</p>
          <ul>
            <li>（1）诸如自然灾害、公共卫生事件（如传染性、流行疾病引发的疫情等）、罢工、暴乱、战争、政府行为、司法行政命令等不可抗力因素；</li>
            <li>（2）因电力供应出现故障、通讯网络发生故障等公共服务方面的因素，或者第三方原因；</li>
            <li>（3）在服帮帮已秉持善意进行管理的前提下，由于常规或紧急的设备与系统维护、设备与系统故障、网络信息与数据安全等因素。</li>
          </ul>
          <h3>8.2 海量信息</h3>
          <p>服帮帮仅为您提供平台服务。您知悉，平台上的信息均由用户自行发布，这些信息可能存在风险与瑕疵。鉴于平台拥有海量信息，且处于信息网络环境下，信息与实物相互分离，服帮帮难以对商品及 / 或服务的每一条信息进行逐一审查，也无法对交易所涉及的商品及 / 或服务的质量、安全性、合法性、真实性以及准确性逐一核实。对此，建议您在交易过程中务必谨慎判断。</p>
          <h3>8.3 调处决定</h3>
          <p>您理解并同意，在争议调处服务中，服帮帮的客服以及大众评审员并非专业法律人士，他们仅能依据普通人的认知水平，对用户提交的凭证进行判断。所以，除调处方存在故意或者重大过失的情况外，调处方对争议调处决定不承担责任。</p>
          <h2>9. 用户信息的保护及授权</h2>
          <h3>9.1 个人信息的保护</h3>
          <p>服帮帮高度重视用户个人信息（即那些能够单独或者与其他信息相结合后识别用户身份的信息）的保护工作，并严格遵守相关法律规定。当您使用服帮帮提供的各项服务时，即表示您同意服帮帮按照在平台上公布的隐私权政策，对您的个人信息进行收集、存储、使用、披露和保护。服帮帮期望通过隐私权政策，清晰地向您阐述对您个人信息的处理方式，故而建议您完整阅读隐私权政策，以便更好地保护您的隐私权。</p>
          <h3>9.2 非个人信息的保证与授权</h3>
          <p><strong>【信息的发布】</strong>您声明并保证，您对您所发布的信息拥有相应、合法的权利。否则，服帮帮可对您发布的信息依法或依本协议进行删除或屏蔽。</p>
          <p><strong>【禁止性信息】</strong>您应当确保您所发布的信息不包含以下内容：</p>
          <ul>
            <li>（1）违反国家法律法规禁止性规定的；</li>
            <li>（2）政治宣传、封建迷信、淫秽、色情、赌博、暴力、恐怖或者教唆犯罪的；</li>
            <li>（3）欺诈、虚假、不准确或存在误导性的；</li>
            <li>（4）侵犯他人知识产权或涉及第三方商业秘密及其他专有权利的；</li>
            <li>（5）侮辱、诽谤、恐吓、涉及他人隐私等侵害他人合法权益的；</li>
            <li>（6）存在可能破坏、篡改、删除、影响服帮帮平台任何系统正常运行或未经授权秘密获取服帮帮平台及其他用户的数据、个人资料的病毒、木马、爬虫等恶意软件、程序代码的；</li>
            <li>（7）其他违背社会公共利益或公共道德或依据相关服帮帮平台协议、规则的规定不适合在服帮帮平台上发布的。</li>
          </ul>
          <p><strong>【授权使用】</strong>对于您提供及发布除个人信息外的文字、图片、视频、音频等非个人信息，在版权保护期内您免费授予服帮帮及其关联公司获得全球排他的许可使用权利及再授权给其他第三方使用的权利。您同意服帮帮及其关联公司存储、使用、复制、修订、编辑、发布、展示、翻译、分发您的非个人信息或制作其派生作品，并以已知或日后开发的形式、媒体或技术将上述信息纳入其它作品内。</p>
          <h2>10. 用户的违约及处理</h2>
          <h3>10.1 违约认定</h3>
          <p>若出现以下情形之一，将被视为您违约：</p>
          <ul>
            <li>（1）在使用服帮帮服务过程中，违反相关法律法规规定；</li>
            <li>（2）违反本协议或本协议补充协议（即本协议第 2.2 条）的约定。</li>
          </ul>
          <p>考虑到电子商务的快速发展以及海量用户对于高效优质服务的迫切需求，您理解并认可，服帮帮有权在平台规则中明确违约认定的具体程序和标准。例如，平台可依据您的用户数据与海量用户数据之间的关联和差异，来综合判断您是否构成违约。同时，若您的数据出现异常情况，您有责任提供充分的证据并作出合理的解释，否则将被判定为违约。</p>
          <h3>10.2 违约处理措施</h3>
          <ul>
            <li>（1）信息处理：若您在服帮帮上发布的信息构成违约，平台将依据相应规则，立即对该信息进行删除、屏蔽操作，或者对您所售商品及 / 或服务进行下架、监管处理，以防止违约信息继续传播和产生不良影响。</li>
            <li>（2）行为限制：若您在平台上实施的行为，或者虽未在平台上实施但对平台及其用户造成影响的行为构成违约，平台有权依照相应规则，对您采取账户扣分、限制参加营销活动、中止向您提供部分或全部服务、划扣违约金等处理措施。若您的行为构成根本违约，平台有权查封您的账户，并终止向您提供服务，以维护平台的正常秩序和其他用户的合法权益。</li>
            <li>（3）第三方支付账户处理：当您违约的同时，存在欺诈、售假、盗用他人账户等特定严重情形，或者您的行为危及他人交易安全或账户安全时，服帮帮将根据您行为的风险程度，通知并指示第三方支付公司采取取消收款、资金止付等强制措施，以保障交易安全和各方权益。</li>
            <li>（4）处理结果公示：服帮帮有权将对您上述违约行为的处理措施信息，以及其他经国家行政或司法机关生效法律文书确认的违法信息，在平台上进行公示，以起到警示和维护平台诚信环境的作用。</li>
            <li>（5）上述4条违约处理措施，平台经营者已着重向用户进行了提示和说明，用户已知晓相关内容且不持任何异议。</li>
          </ul>
          <h3>10.3 赔偿责任</h3>
          <ul>
            <li>（1）若您的行为致使服帮帮及 / 或其关联公司、第三方支付公司遭受损失（包括但不限于自身的直接经济损失、因声誉受损而产生的商誉损失，以及对外支付的赔偿金、和解款、律师费、诉讼费等间接经济损失），您应当对上述全部损失予以赔偿，以弥补受损方的实际损失。</li>
            <li>（2）若您的行为导致服帮帮及 / 或其关联公司、第三方支付公司遭受第三人主张权利，在服帮帮及 / 或其关联公司对第三人承担金钱给付等义务后，有权就全部损失向您进行追偿，您应予以配合并承担相应费用。</li>
            <li>（3）若因您的行为使第三人遭受损失，或者您怠于履行调处决定，服帮帮及 / 或其关联公司出于社会公共利益保护或消费者权益保护目的，可指示通知第三方支付公司从您的第三方支付账户中划扣相应款项进行支付，您对此予以认可且不持异议。若您的第三方支付账户余额或保证金不足以支付相应款项，您同意委托服帮帮使用自有资金代您支付上述款项，同时您应当返还该部分费用，并赔偿因此给服帮帮造成的全部损失。</li>
            <li>（4）您同意服帮帮指示通知第三方支付公司从您的第三方支付账户中划扣相应款项支付上述赔偿款项。若您的第三方支付账户中的款项不足以支付上述赔偿款项，服帮帮及 / 或关联公司可直接抵减您在服帮帮及 / 或其关联公司其它协议项下的权益，并有权继续向您追偿剩余款项。</li>
          </ul>
          <h3>10.4 特别约定</h3>
          <ul>
            <li>（1）商业贿赂：若您向服帮帮及 / 或其关联公司的雇员或顾问等提供实物、现金、现金等价物、劳务、旅游等价值明显超出正常商务洽谈范畴的利益，将被视为您存在商业贿赂行为。一旦发生此类情形，服帮帮有权立即终止与您的所有合作，并向您收取违约金及 / 或赔偿金，具体金额将以服帮帮因您的贿赂行为而遭受的经济损失和商誉损失作为计算依据，以惩戒此类不正当行为。</li>
            <li>（2）关联处理：若您因严重违约导致服帮帮终止本协议，出于维护平台秩序及保护消费者权益的目的，服帮帮及 / 或其关联公司有权对与您在其他协议项下的合作采取中止甚至终止协议的措施，并按照本协议第八条约定的方式通知您。此外，若服帮帮与您签署的其他协议及服帮帮及 / 或其关联公司、第三方支付公司与您签署的协议中明确约定了对您在本协议项下合作进行关联处理的情形，服帮帮出于维护平台秩序及保护消费者权益的目的，可在收到指令时中止甚至终止协议，并以本协议第八条约定的方式通知您。</li>
          </ul>
          <h2>11. 协议的变更</h2>
          <p>服帮帮可根据国家法律法规的变化，以及维护交易秩序、保护消费者权益的实际需要，适时对本协议、补充协议进行修改。变更后的协议、补充协议（以下简称 “变更事项”）将通过法定程序，并按照本协议第八条约定的方式通知您。</p>
          <p>若您不同意变更事项，您有权在变更事项确定的生效日前，及时联系服帮帮反馈意见。平台将对您的反馈意见进行认真研究，若反馈意见合理并被采纳，平台将酌情对变更事项进行调整。</p>
          <p>若您对已生效的变更事项仍持不同意态度，您应当在变更事项确定的生效之日起，停止使用服帮帮服务，此时变更事项对您不产生效力；若您在变更事项生效后仍继续使用平台服务，则视为您同意已生效的变更事项。</p>
          <h2>12. 通知</h2>
          <h3>12.1 有效联系方式</h3>
          <p>在您注册成为服帮帮用户，并接受平台服务时，您有责任向平台提供真实、准确、有效的联系方式（包括您的电子邮件地址、联系电话、联系地址等）。若联系方式发生变更，您应及时更新相关信息，确保始终处于可被联系的状态。</p>
          <p>您在注册服帮帮用户时生成的用于登录平台接收站内信、系统消息和 IM 即时信息的会员账号，也将被视为您的有效联系方式之一。</p>
          <p>服帮帮将通过上述联系方式中的一种或多种，向您送达各类通知。这些通知的内容可能对您的权利和义务产生重大的有利或不利影响，请您务必密切关注并及时查看。</p>
          <h3>12.2 通知的送达</h3>
          <ul>
            <li>（1）服帮帮通过上述联系方式向您发出通知，其中以电子方式发出的书面通知，包括但不限于在平台公告、向您提供的联系电话发送手机短信、向您提供的电子邮件地址发送电子邮件、向您的账号发送系统消息以及站内信信息，在发送成功后即视为送达；以纸质载体发出的书面通知，按照您提供的联系地址交邮后的第五个自然日即视为送达。</li>
            <li>（2）对于在服帮帮上因交易活动引发的任何纠纷，您同意司法机关（包括但不限于人民法院）可以通过手机短信、电子邮件等现代通讯方式或邮寄方式向您送达法律文书（包括但不限于诉讼文书）。您指定接收法律文书的手机号码、电子邮箱账号等联系方式为您在平台注册、更新时提供的手机号码、电子邮箱联系方式以及在注册服帮帮用户时生成的账号，司法机关向上述联系方式发出法律文书即视为送达。您指定的邮寄地址为您的法定联系地址或您提供的有效联系地址。</li>
            <li>（3）您同意司法机关可采取以上一种或多种送达方式向您送达法律文书，若司法机关采取多种方式向您送达法律文书，送达时间以上述送达方式中最先送达的为准。</li>
            <li>（4）您同意上述送达方式适用于各个司法程序阶段，如进入诉讼程序的，包括但不限于一审、二审、再审、执行以及督促程序等。</li>
            <li>（5）您应当保证所提供的联系方式准确、有效，并及时进行更新。若因提供的联系方式不准确，或未及时告知变更后的联系方式，导致法律文书无法送达或未及时送达，由此产生的法律后果将由您自行承担。</li>
          </ul>
          <h2>13. 协议的终止</h2>
          <h3>13.1 终止的情形</h3>
          <p><strong>【用户发起的终止】</strong>您有权通过以下任一方式终止本协议：</p>
          <ul>
            <li>（1）在满足服帮帮公示的账户注销条件时您通过网站自助服务注销您的账户的；</li>
            <li>（2）变更事项生效前您停止使用并明示不愿接受变更事项的；</li>
            <li>（3）您明示不愿继续使用服帮帮平台服务，且符合服帮帮终止条件的。</li>
          </ul>
          <p><strong>【服帮帮发起的终止】</strong>出现以下情况时，服帮帮可以本协议第八条的所列的方式通知您终止本协议：</p>
          <ul>
            <li>（1）您违反本协议约定，服帮帮依据违约条款终止本协议的；</li>
            <li>（2）您盗用他人账户、发布违禁信息、骗取他人财物、售假、扰乱市场秩序、采取不正当手段谋利等行为，服帮帮依据服帮帮平台规则对您的账户予以查封的；</li>
            <li>（3）除上述情形外，因您多次违反平台规则相关规定且情节严重，服帮帮依据服帮帮平台规则对您的账户予以查封的；</li>
            <li>（4）您的账户被服帮帮依据本协议回收的； </li>
            <li>（5）您在第三方支付公司或服帮帮平台有欺诈、发布或销售假冒伪劣/侵权商品、侵犯他人合法权益或其他严重违法违约行为的；</li>
            <li>（6）其它应当终止服务的情况。</li>
          </ul>
          <h3>13.2 协议终止后的处理</h3>
          <p><strong>【用户信息披露】</strong>本协议终止后，除法律有明确规定外，服帮帮无义务向您或您指定的第三方披露您账户中的任何信息。</p>
          <p><strong>【交易处理】</strong>本协议终止后，对于您在本协议存续期间产生的交易订单，服帮帮可通知交易相对方并根据交易相对方的意愿决定是否关闭该等交易订单；如交易相对方要求继续履行的，则您应当就该等交易订单继续履行本协议及交易订单的约定，并承担因此产生的任何损失或增加的任何费用。</p>
          <h2>14. 法律适用、管辖与其他</h2>
          <ul>
            <li>（1）法律适用：本协议的订立、生效、解释、修订、补充、终止、执行与争议解决均适用中华人民共和国大陆地区法律；如法律无相关规定的，参照商业惯例及 / 或行业惯例，以确保协议的执行和争议解决有法可依、有据可循。</li>
            <li>（2）管辖：您因使用服帮帮服务所产生及与平台服务有关的争议，由服帮帮与您协商解决。协商不成时，任何一方均可向平台经营者所在地具有管辖权的人民法院提起诉讼，明确争议解决的管辖法院，便于纠纷的有效处理。</li>
            <li>（3）可分性：本协议任一条款被视为废止、无效或不可执行，该条应视为可分的且并不影响本协议其余条款的有效性及可执行性，保障协议整体的稳定性和有效性。</li>
          </ul>
        </div>
      </div>
    </section>
  </div>
);

export default Terms; 